<template>

</template>


<script>
    // import StorageBase from "./StorageBase";
    import StorageBase from "./ModelStorageBase";
    import TenantAware from "../../labs/TenantAware"

    import * as io from 'socket.io-client'

    function Queue() {
        this.elements = [];
    }

    Queue.prototype.enqueue = function (e) {
        this.elements.push(e);
    };

    Queue.prototype.dequeue = function () {
        return this.elements.shift();
    };

    Queue.prototype.isEmpty = function () {
        return this.elements.length == 0;
    };

    Queue.prototype.peek = function () {
        return !this.isEmpty() ? this.elements[0] : undefined;
    };

    Queue.prototype.clear = function () {
        this.elements = [];
    };

    Queue.prototype.removeByIndex = function (index) {
        this.elements.splice(index, 1);
    }

    Queue.prototype.findIndexByChildKey = function (key) {
        return this.elements.findIndex(element => element.childKey == key)
    }

    Queue.prototype.length = function () {
        return this.elements.length;
    }

    var queueFifo = new Queue();

    var fs = require('fs');
    var _ = require('lodash');
    var Minio = require('minio');
    var Base64 = require('js-base64').Base64;
    var yamlpaser = require('js-yaml');
    var FileSaver = require('file-saver');
    var changeCase = require('change-case');
    var pluralize = require('pluralize');
    var JSZip = require('jszip')
    var path = require('path')


    var jsondiffpatch = require('jsondiffpatch').create({
        objectHash: function (obj, index) {
            return '$$index:' + index;
        },
    });

    var jp = require('jsonpath');


    export default {
        mixins: [TenantAware, StorageBase],
        name: 'model-canvas',
        components: {
            io
        },
        props: {
            renderCount:{
                type: Number,
                default: 0
            },
            sliderLocationScale: {
                type: Number,
                default: function () {
                    return 1;
                }
            },
            value: {
                type: Object,
                default: function () {
                    return {'elements': {}, 'relations': {}}
                }
            },
            fork:{
                type: Boolean,
                default: function () {
                    return false;
                }
            },
            projectId: {
                type: String,
                default: function () {
                    return null;
                }
            },
            projectTitle: {
                type: String,
                default: function () {
                    return ''
                }
            },
            projectName: {
                type: String,
                default: function () {
                    return ''
                }
            },
            dragPageMovable: {
                type: Boolean,
                default: function () {
                    return false;
                }
            },
            automaticGuidance: {
                default: function () {
                    return true;
                },
                type: Boolean
            },
            readOnly: {
                type: Boolean,
                default: function () {
                    return false;
                }
            },
            disableModel: {
                type: Boolean,
                default: function () {
                    return false;
                }
            },
            isQueueModel: {
                type: Boolean,
                default: function () {
                    return false;
                }
            },
            embedded: {
                type: Boolean,
                default: function () {
                    return false;
                }
            },
        },
        data() {
            return {
                //sep
                paneLengthPercent: 100,
                // Template Code
                changedTemplateCode: false,
                autoSyncTemplateId: null,
                oldTreeHashLists: null,
                newTreeHashLists: null,
                showTemplatePath: false,
                changedPathLists: [],
                changedPathListsBucket: [],
                showChangedPathLists: false,
                isChangedPathLists: false,

                //base
                fab: false,
                windowWidth: window.innerWidth,
                // user: {},
                app: null,
                fullPath: null,
                params: null,
                paramKeys: null,
                canvas: null,
                canvasType: 'es',
                isAutoForkModel:  false,
                canvasValidationResults: [],

                //overlay
                overlayText: null,

                //invite
                invitationLists: null,
                inviteDialog: false,
                participantLists: [],
                information: null,
                specVersion: '1.0',
                joinRequested: false,

                storageDialog: false,
                undoDisable: false,
                redoDisable: false,

                //clusters
                clusterItems: [
                    // {title: 'Terminal'},
                    // {title: 'Sync'},
                    // {title: 'Cluster'},
                ],
                clusterInfo: {},
                clusterDialog: false,

                //firebase
                lastSnapshotKey: null,
                lastSnapQueueKey: null,
                latestQueueKey: null,
                receivedQueueExistValue: false,
                changedByMe: false,
                changedByMeKeys: [],
                receivedQueueItemCountAfterLastSnapshot: 0,
                snapshotFrequency: 50,

                //share - invitationLists
                showPublicModel: false,
                permissionTypes: ['ReadOnly', 'Write'],
                showParticipantPanel: false,

                //project

                changed: false,
                initLoad: false,
                title: '',
                comment: '',
                isMineProject: false,
                isServerModel: false,

                //Save,fork
                storageCondition: null,
                /*
                    forkLatest : 원본모델 접근시 ( 해당 유저가 최근에 포크한 모델 ID)
                    forkOrigin : 포크모델 접근시 ( 해당 유저가 해당 모델의 원본 모델 ID)
                */
                forkInformation:{
                    forkOrigin: null,
                    forkLatest : null,
                },
                purchaseItemDialog: false,
                purchaseItemDialogInfo: {
                    mainTitle: null,
                    title: null,
                    subTitle: null,
                    itemId: null,
                    thumbnailText: null,
                    thumbnailImg: null,
                    resourceType: null,
                    className: null,
                    labName: null,
                    period: 90,
                    count: 0,
                    amount: 0,
                },

                //undo,Redo
                undoRedoArray: [],
                undoRedoIndex: 0,
                changedByUndoRedo: false,
                undoRedoState: null,

                //rtc
                rtcRoomId: 'room',

                //icon
                icon: {
                    version: 'mdi-server',
                    code: 'mdi-code-array',
                    save: 'mdi-content-save',
                    open: 'mdi-book-open',
                    md: 'mdi-language-markdown',
                    txt: 'mdi-file-document-outline',
                    java: 'mdi-language-java',
                    xml: 'mdi-xml',
                    shell: 'mdi-powershell',
                    docker: 'mdi-docker',
                    png: 'mdi-file-image',
                    json: 'mdi-code-json',
                    python: 'mdi-language-python',
                    fork: ' mdi-silverware-fork',
                    share: 'mdi-share-variant',
                    join: 'mdi-account-multiple-plus',
                    vue: 'mdi-vuejs',
                    js: 'mdi-language-javascript',
                    html: 'mdi-language-html5',
                    go: 'mdi-language-go',
                    properties: 'mdi-cog'
                },
                debounceTime: 0,
                //스낵바 옵션
                snackbar: {
                    show: false,
                    color: 'error',
                    mode: 'multi-line',
                    timeout: 6000,
                    text: '',
                    top: true,
                    bottom: false,
                    centered: false,
                    showCloseBtn: true,
                },
                alertInfo: {
                    show: false,
                    type: 'warning',
                    border: 'left',
                    maxWidth: 550,
                    text: '확인',
                    submit: null,
                    fnNum: 0,
                    color: 'orange',
                    link: null
                },
                codeModalCheck: false,
                checkingBilling: false,

                // rtc
                rtcLogin: false,
                webRtcDialog: false,

                //internet
                disconnect: false,
            }
        },
        beforeDestroy: function () {
            var me = this
            //embedded
            if (me.embedded) {
                return
            }
            if(window.opener) {
                window.opener = null;
            }


            if (!me.isClazzModeling)
                localStorage.removeItem('projectId')

            if (me.rtcLogin)
                me.onLeave()
            this.$EventBus.$emit('participant', [])
            window.removeEventListener('resize', this.onResize);

            if (me.sortScheduleId) {
                clearTimeout(me.sortScheduleId)
            }

            me.$refs['modeler-image-generator'].save(me.projectName, me.canvas).then(async function (resolve) {

                if ((me.isServerModeling && !me.isClazzModeling) && !me.readOnly) {
                    await me.exitUser()

                    if (me.initLoad && me.changed) {

                        var putObj = {
                            img: resolve,
                            lastModifiedDate: Date.now(),
                            lastModifiedUser: me.userInfo.uid,
                            lastModifiedEmail: me.userInfo.email,
                            projectName: me.projectName,
                        }
                        await me.putObject(`db://definitions/${me.projectId}/information`, putObj)
                    }
                } else if (!me.isClazzModeling) {

                    var lists = localStorage.getItem('localLists')
                    if (lists) {
                        lists = JSON.parse(lists)
                        var index = lists.findIndex(list => list.projectId == me.projectId)
                        if (index != -1) {
                            if (localStorage.getItem(me.projectId)) {
                                lists[index].img = resolve
                                lists[index].projectName = me.projectName
                            } else {
                                lists.splice(index, 1)
                            }
                            await me.putObject(`localstorage://localLists`, lists)
                        }
                    }
                }else if(me.isClazzModeling){

                }

            })
        },
        computed: {
            filteredCanvasValidationResults(){
                var me = this
                var levelSort = ['error','warning','info']
                try{
                    return me.canvasValidationResults.sort(function compare(a, b) {
                        var aIdx = levelSort.findIndex(x=>x == a.level)
                        var bIdx = levelSort.findIndex(x=>x == b.level)
                        return aIdx - bIdx;
                    });
                }catch (e) {
                    return me.canvasValidationResults
                }
            },
            isInitRender(){
                if(this.renderCount == 0 ){
                    return true
                }
                return  false
            },
            getScale: {
                getter: function () {
                    console.log("aa")
                    return this.sliderLocationScale
                }
            },
            isForeign() {
                if (window.countryCode == 'ko') {
                    return true
                }
                return true
            },
            modelingProjectId(){
                return this.projectId
            },
            isCustomMoveExist(){
                if (this.isServerModeling && this.isQueueModeling) {
                    return !this.isReadModeling
                }
                return false
            },
            isQueueModeling() {
                return this.isQueueModel
            },
            isServerModeling() {
                return this.isServerModel
            },
            isReadModeling() {
                return this.readOnly
            },
            isClazzModeling() {
                var me = this
                if (me.paramKeys && me.paramKeys.includes('classId')) {
                    return true
                }
                return false
            },
            isForkedModeling(){
                // fork 했던 모델.
                if(this.forkInformation && this.forkInformation.forkOrigin){
                    return true
                }
                return false
            },
            joinRequestedText() {
                var obj = {
                    show: true,
                    text: 'Join',
                }

                if (this.joinRequested) {
                    obj.show = false
                    obj.text = 'Join Requested'
                    return obj
                }
                return obj
            },
            requestCount() {

                if (this.information && this.information.permissions) {
                    var array = Object.values(this.information.permissions)
                    return array.filter((word) => {
                        if (word)
                            return word.request == true
                    }).length
                }

                return null
            },
            isClosedTemplateCode() {
                if (this.paneLengthPercent > 98) {
                    return true
                }
                return false
            },
            isMobile: function () {
                if (this.paneLengthPercent < 96)
                    return true
                return this.windowWidth <= 781
            },
            showOverlay() {
                return this.overlayText
            },
            storage() {
                var me = this
                if (me.isServerModeling && !me.isClazzModeling) {
                    return 'db'
                } else {
                    return 'localstorage'
                }
            },
            fixedDefalutStroage() {
                return 'db'
            },
            checkUndo() {
                var me = this
                if (!me.isServerModeling || me.isClazzModeling) {
                    if (me.undoRedoIndex == 0) {
                        return true
                    } else {
                        return false
                    }
                } else {
                    return me.undoDisable
                }
            },
            checkRedo() {
                var me = this
                if (!me.isServerModeling || me.isClazzModeling) {
                    if (me.undoRedoIndex == me.undoRedoArray.length) {
                        return true
                    } else {
                        return false
                    }
                } else {
                    return me.redoDisable
                }
            },
            copyValue() {
                return _.cloneDeep(this.value)
            },
            inviteLists() {
                return this.invitationLists
            },
            showStorageDialog() {
                return this.storageDialog
            },
        },
        created: async function () {
            var me = this
            if (me.embedded) {
                return
            }

            me.$EventBus.$emit('showNewButton', false)
            //set userInfo
            await me.loginUser()
            window.io = io
            me.app = this.getComponent('App')

            if (me.isMobile) {
                me.sliderLocationScale = 0.7
            }


            //initialize if never initialized before
            if (!me.value || !me.value.relations) {
                me.value = {}
                me.value.relations = {}
            }
            if (!me.value || !me.value.elements) {
                me.value.elements = {};
            }

            // URL
            me.fullPath = this.$route.fullPath.split('/')
            me.params = this.$route.params
            me.paramKeys = Object.keys(me.params)

            // user
            // me.user.uid = localStorage.getItem('uid')
            // me.user.name = localStorage.getItem('userName')
            // me.user.email = localStorage.getItem('email')
            // me.user.accessToken = localStorage.getItem('accessToken')
            // me.user.picture = localStorage.getItem('picture')


            await me.loadDefinition()

            if(me.isServerModel && !me.isAutoForkModel) {
                me.updatePermission()
            }

            if (me.isServerModeling) {
                if (me.isQueueModeling) {
                    if (me.disableModel){
                        me.initLoad = true
                        me.$EventBus.$emit('progressValue', false)
                    }else {
                        me.receiveQueue()
                    }
                } else {
                    me.receiveValueSpecOne()
                }
            }
        },
        mounted: function () {
            var me = this
            if (!me.value.relations) {
                me.value.relations = {}
            }
            if (!me.value.elements) {
                me.value.elements = {};
            }

            me.debounceTime = 1000

            me.$EventBus.$on('participantPanel', function (newVal) {
                me.showParticipantPanel = newVal
            })

            me.$EventBus.$on('snackbar', function (newVal) {
                me.snackbar.color = newVal.color ? newVal.color : ''
                me.snackbar.mode = newVal.mode ? newVal.mode : 'multi-line'
                me.snackbar.timeout = newVal.timeout ? newVal.timeout : 2000
                me.snackbar.text = newVal.text ? newVal.text : ''
                me.snackbar.top = newVal.top ? newVal.top : false
                me.snackbar.bottom = newVal.bottom ? newVal.bottom : false
                me.snackbar.show = newVal.show ? newVal.show : false
                me.snackbar.centered = newVal.centered ? newVal.centered : false
                me.snackbar.showCloseBtn = newVal.showCloseBtn ? newVal.showCloseBtn : false
            })

            this.$nextTick(() => {
                window.addEventListener('resize', this.onResize);
            })

            //새로고침 감지 && 탭 닫기
            window.onbeforeunload = function (e) {
                console.log('reload')
                if ((me.isServerModeling && !me.isClazzModeling) && !me.readOnly) {
                    me.exitUser()
                }
            }


            me.isConnection('db://', function (connection) {
                console.log('connection', connection)
                if (!connection && me.isServerModeling && !me.isClazzModeling) {
                    me.disconnect = true
                    alert("현재 네트워크에 연결되어 있지 않습니다. \n" +
                        "현재 동시편집 기능을 이용중 이라시면 동시편집의 전체적인 데이터 손실이 될수 있습니다.\n" +
                        "네트워크 연결 후에 작업 해주시길 바랍니다. ");
                }
            })


            me.$EventBus.$on('login', async function (newVal) {
                if (newVal) {
                    await me.setUserInfo()
                    if (me.information && me.isServerModeling)
                        me.settingPermission(me.information)
                }
            })


            this.$nextTick(function () {

                let startTime = Date.now()

                if (this.canvas) this.canvas._CONFIG.FAST_LOADING = false;

                if (this.$refs.opengraph) this.$refs.opengraph.printTimer(startTime, Date.now());

                $(document).keydown((evt) => {
                    if (evt.keyCode == 67 && (evt.metaKey || evt.ctrlKey)) {
                        me.copy();
                    } else if (evt.keyCode == 86 && (evt.ctrlKey || evt.metaKey)) {
                        me.paste();

                    } else if (evt.keyCode == 90 && (evt.metaKey || evt.ctrlKey)) {
                        if (evt.shiftKey) {
                            if (!me.readOnly) {
                                // me.redo();
                            }
                        } else {
                            if (!me.readOnly) {
                                // me.undo();
                            }

                        }
                    }

                });

            });
        },
        watch: {
            "sliderLocationScale": function (newVal) {
                console.log(newVal)
            },
            "projectName": function (newVal) {
                var me = this
                if (me.initLoad) {
                    me.changed = true
                }
            },
            webRtcDialog: function (newVal, oldVal) {
                if (newVal == false) {
                    this.onLeave()
                }
            },
            participantLists: {
                dep: true,
                handler: _.debounce(function (newVal, oldVal) {
                    this.$EventBus.$emit('participant', newVal)
                }, 1000)
            },

        },
        methods: {
            clearChangedPathListsBucket(){
                this.changedPathListsBucket = []
                this.showChangedPathLists = false
            },
            autoForkModel(){
                var me = this

                // labs 모델 파악.
                if(me.isServerModel){
                    if(
                        me.information &&
                        ( me.information.author == me.userInfo.uid )
                        || ( me.information.permissions && me.information.permissions['everyone'])
                    ){
                        //server - everyone공유된거만.
                        if(me.isLogin){
                            me.checkedForkModel()
                        }else{
                            me.$EventBus.$emit('showLoginDialog')
                        }
                    }else{
                        alert('권한이 없는 모델입니다.( Public에 존재하는 모델만 가능 합니다.) ')
                    }

                }else{
                    //local
                    alert('로컬 모델로 해당기능 준비중 입니다.')
                }
            },
            onMoveElementById(id, newValueStr) {
                var me = this

                if (me.value && me.value.elements && me.value.elements[id]) {
                    var newValueObj = JSON.parse(newValueStr)

                    me.value.elements[id].elementView.x = newValueObj.x
                    me.value.elements[id].elementView.y = newValueObj.y
                    me.value.elements[id].elementView.width = newValueObj.width
                    me.value.elements[id].elementView.height = newValueObj.height
                }
            },
            onMoveRelationById(id, newValueObj) {
                var me = this

                if (me.value && me.value.relations && me.value.relations[id]) {
                    me.value.relations[id].relationView.value = newValueObj
                }
            },
            functionCluster(title) {
                var me = this
                if (title == 'Terminal') {
                    me.loadTerminal = true;
                    me.$EventBus.$once('loadTerminal', function () {
                        me.loadTerminal = false
                    })
                    me.terminal()
                } else if (title == 'Sync') {
                    me.deployDialog = true
                } else if (title == 'Cluster') {
                    me.clusterDialog = true
                } else if (title == 'Workflow Dashboard') {
                    me.openArgoDashboard();
                } else if (title == 'ArgoCD Dashboard') {
                    me.openArgoCdDashboard();
                }
            },
            track() {
                this.$gtag.pageview(
                    {
                        page_title: `${this.canvasType} 모델링`,
                        page_path: this.$route.path
                    }
                )
            },
            onJoin() {
                this.webRtcDialog = true
                this.rtcLogin = true
                if (this.$refs)
                    this.$refs.webrtc.join();
            },
            onLeave() {
                this.rtcLogin = false
                if (this.$refs)
                    this.$refs.webrtc.leave();
            },
            onCapture() {
                if (this.$refs)
                    this.img = this.$refs.webrtc.capture();
            },
            onShareScreen() {
                if (this.$refs)
                    this.img = this.$refs.webrtc.shareScreen();
            },
            enterUser() {
                var me = this
                if (me.isQueueModeling && me.isInitRender && !me.isReadModeling && !me.isClazzModeling && !me.isHexagonalModeling) {
                    var postObj = {
                        action: 'userEntrance',
                        picture: me.userInfo.profile,
                        editUid: me.userInfo.uid,
                        email: me.userInfo.email,
                        userName: me.userInfo.name,
                        timeStamp: Date.now(),
                    }
                    me.pushObject(`db://definitions/${me.projectId}/queue`, postObj)
                }
            },
            exitUser() {
                var me = this
                if (me.isQueueModeling && !me.isReadModeling && me.isInitRender && !me.isClazzModeling && !me.isHexagonalModeling) {
                    var pushObj = {
                        action: 'userExit',
                        editUid: me.userInfo.uid,
                        email: me.userInfo.email,
                        userName: me.userInfo.name,
                        timeStamp: Date.now(),
                    }
                    me.pushObject(`db://definitions/${me.projectId}/queue`, pushObj)
                }
            },
            settingPermission(information, init) {
                var me = this
                me.information = information ? information : me.information
                me.projectName = me.isClazzModeling && me.projectTitle ? me.projectTitle : ( me.information && me.information.projectName ) ? me.information.projectName : 'untitled'
                // me.isAutoForkModel = me.isClazzModeling ? (me.information.author == me.userInfo.uid && !me.information.RegisteredLabName ? false : true) : Object.keys(this.$route.query).includes('fork')
                me.isAutoForkModel = me.isClazzModeling ? false : Object.keys(this.$route.query).includes('fork')

                var toppingList = me.information.prefferdToppings
                me.$EventBus.$emit('prefferdToppings', toppingList)

                if (!me.isClazzModeling) {
                    if (me.information.author == me.userInfo.uid) {
                        //my project
                        me.isMineProject = true
                        me.readOnly = false

                    } else {
                        me.isMineProject = false

                        if (me.isLogin) {
                            if (me.information.permissions) {
                                var all = false
                                if (me.information.permissions['everyone']) {
                                    all = true
                                }
                                if (me.information.permissions[me.userInfo.uid]) {
                                    if (Object.keys(me.information.permissions[me.userInfo.uid]).includes('request')) {
                                        me.readOnly = true
                                        if (me.information.permissions[me.userInfo.uid].request == false) {
                                            me.alertInfo.show = true
                                            me.alertInfo.text = '접근권한 요청 후 수락이 되지 않았습니다'
                                            me.alertInfo.type = 'info'
                                            if (all) {
                                                me.alertInfo.fnNum = 0
                                            } else {
                                                me.disableModel = true
                                                me.alertInfo.fnNum = 1
                                                me.alertInfo.submit = '재요청'
                                            }
                                        } else if (me.information.permissions[me.userInfo.uid].request == true) {
                                            me.joinRequested = true
                                            me.alertInfo.show = true
                                            me.alertInfo.text = '요청 후 권한자 미확인 상태 입니다'
                                            me.alertInfo.type = 'info'
                                            if (all) {
                                                me.alertInfo.fnNum = 0
                                            } else {
                                                me.disableModel = true
                                                me.alertInfo.fnNum = 1
                                                me.alertInfo.submit = '재요청'
                                            }

                                        }
                                    } else if (me.information.permissions[me.userInfo.uid].write) {
                                        me.readOnly = false
                                    } else {
                                        me.readOnly = true
                                        // me.forkAlertDialog = true
                                    }
                                } else {
                                    if (all) {
                                        me.readOnly = true
                                        // me.forkAlertDialog = true
                                    } else {
                                        me.readOnly = true
                                        me.disableModel = true
                                        me.alertInfo.show = true
                                        me.alertInfo.text = '접근권한이 없는 모델 입니다.'
                                        me.alertInfo.type = 'info'
                                        me.alertInfo.fnNum = 1
                                        me.alertInfo.submit = '권한 요청'
                                    }
                                }
                            } else {
                                me.readOnly = true
                                me.disableModel = true
                                me.alertInfo.show = true
                                me.alertInfo.text = '접근권한이 없는 모델 입니다.'
                                me.alertInfo.type = 'info'
                                me.alertInfo.fnNum = 1
                                me.alertInfo.submit = '권한 요청'
                            }
                        } else {
                            if (me.information && me.information.permissions && me.information.permissions['everyone']) {
                                me.readOnly = true
                            } else {
                                me.readOnly = true
                                me.disableModel = true
                                me.alertInfo.show = true
                                me.alertInfo.text = '접근권한이 없는 모델 입니다.'
                                me.alertInfo.fnNum = 1
                                me.alertInfo.submit = '권한 요청'
                            }

                        }
                    }
                }else if(me.isClazzModeling){
                    if (me.information.author == me.userInfo.uid) {
                        me.readOnly = false
                    } else if(me.information && me.information.permissions && me.information.permissions['everyone']){
                        me.readOnly = true
                    } else {
                        me.readOnly = true
                        me.alertInfo.text = '접근권한이 없는 모델 입니다.'
                        me.alertInfo.fnNum = 1
                        me.alertInfo.submit = '권한 요청'
                    }
                }
            },
            alertClose(fnNum) {
                var me = this
                if (fnNum == 1) {
                    me.$router.push('/')
                }

                me.alertInfo.show = false
                me.alertInfo.text = ''
            },
            alertSubmit(fnNum) {
                var me = this

                if (fnNum == 0) {
                    me.alertClose()
                } else if (fnNum == 1) {
                    me.requestInviteUser()
                    me.alertClose(fnNum)
                } else if (fnNum == 2) {
                    me.$EventBus.$emit('showLoginDialog')
                    me.alertClose()
                }
            },
            purchaseItemDialogSubmit(itemName) {
                console.log('root : purchaseItemDialogSubmit', itemName)
            },
            async purchaseItemDialogOpen(id) {
                var me = this
                var getItemId = id

                if (me.isLogin) {
                    var filtered = me.filterProjectName(me.projectName)
                    if (filtered.replace(/\s/gi, "") == '') {
                        me.projectName = window.prompt("Please input your ProjectName(English Only)")
                    } else {
                        me.purchaseItemDialogInfo.mainTitle = ''
                        me.purchaseItemDialogInfo.title = '소스코드 다운'
                        me.purchaseItemDialogInfo.resourceType = 'downloadCode'
                        me.purchaseItemDialogInfo.period = 10 / (24 * 60)
                        me.purchaseItemDialogInfo.itemId = `${getItemId}`
                        me.purchaseItemDialogInfo.relatedTo = `${me.userInfo.uid}_${getItemId}`
                        me.purchaseItemDialogInfo.amount = 100
                        me.purchaseItemDialog = true
                    }
                } else {
                    me.alertInfo.show = true
                    me.alertInfo.text = '해당 기능은 로그인후 사용이 가능합니다.'
                    me.alertInfo.fnNum = 2
                    me.alertInfo.submit = 'Login'
                }

                me.generateZipDialog = false
            },
            purchaseItemDialogInfoInit() {
                this.purchaseItemDialogInfo.mainTitle = null
                this.purchaseItemDialogInfo.title = null
                this.purchaseItemDialogInfo.subTitle = null
                this.purchaseItemDialogInfo.thumbnailText = null
                this.purchaseItemDialogInfo.resourceType = null
                this.purchaseItemDialogInfo.thumbnailImg = null
                this.purchaseItemDialogInfo.relatedTo = null
                this.purchaseItemDialogInfo.period = 90
                this.purchaseItemDialogInfo.count = false
                this.purchaseItemDialogInfo.itemId = null
                this.purchaseItemDialogInfo.amount = null
                this.purchaseItemDialogInfo.className = null
                this.purchaseItemDialogInfo.labName = null
            },
            purchaseItemDialogClose(result) {
                if (result != false) {
                    this.purchaseItemDialogInfoInit()
                }
                this.purchaseItemDialog = false
                this.generateZipDialog = false
            },
            onResize() {
                this.windowWidth = window.innerWidth
            },
            _isAttached(outer, inner) {
                if (
                    //왼쪽 상단 모서리에 걸린 경우
                    (outer.x < inner.x + inner.width &&
                        outer.y < inner.y + inner.height)

                    &&

                    //우측 하단 모서리에 걸린 경우
                    (inner.x < outer.x + outer.width &&
                        inner.y < outer.y + outer.height)

                    &&

                    //오른쪽 상단 모서리에 걸린 경우
                    (inner.x < outer.x + outer.width &&
                        outer.y < inner.y + inner.height)

                    &&

                    //왼쪽 하단 모서리에 걸린 경우
                    (outer.x < inner.x + inner.width &&
                        inner.y < outer.y + outer.height)
                ) return true;

                return false;
            },
            closeOverlay() {
                this.overlayText = null
            },
            downloadModelToJson() {
                var me = this;

                if (me.projectName.length < 1) {
                    me.projectName = window.prompt("Please input your ProjectName")

                } else {
                    me.$refs['modeler-image-generator'].save(me.projectName, me.canvas).then(function (img) {

                        var cpValue = JSON.parse(JSON.stringify(me.value))
                        cpValue.type = me.information ? me.information.type : me.canvasType
                        cpValue.img = img
                        cpValue.date = Date.now()
                        cpValue.projectName = me.projectName ? me.projectName : 'undefined'

                        var filename = me.projectName + '.json';

                        var modelForJsonToTextFile = new File([JSON.stringify(cpValue)], filename, {
                            type: "text/json;charset=utf-8"
                        });
                        FileSaver.saveAs(modelForJsonToTextFile);
                        alert('Successfully Saved', me.projectName, '.')

                    })
                }

            },
            saveComposition(state, gitOrgName, gitRepoName) {
                var me = this
                // if (me.isClazzModeling) {
                //     me.downloadModelToJson()
                // } else {
                    me.storageDialogReady(state, gitOrgName, gitRepoName)
                // }
            },
            async storageDialogReady(state, gitOrgName, gitRepoName) {
                var me = this
                if (me.isLogin) {
                    var obj = null
                    var proName = me.projectName ? me.projectName : 'untitled'

                    if (state == 'save') {
                        if (window.opener && me.canvasType == 'k8s') {
                            me.postParentWindow();
                        } else if (me.isServerModeling && !me.isClazzModeling) {
                            obj = {
                                action: 'backup',
                                title: 'Save New Version',
                                projectName: proName,
                                editProjectName: JSON.parse(JSON.stringify(proName)),
                                content: null,
                                comment: me.comment
                            }
                        } else {
                            obj = {
                                action: 'save',
                                title: 'SAVE',
                                projectName: proName,
                                content: null,
                                comment: me.comment,
                            }
                        }

                    } else if (state == 'fork') {
                        var forkBy ={
                            gitOrgName : gitOrgName,
                            gitRepoName: gitRepoName
                        }

                        obj = {
                            action: 'fork',
                            title: 'FORK',
                            projectName: proName,
                            editProjectName: JSON.parse(JSON.stringify(proName)),
                            userId: me.forkInformation.forkLatest ? me.userInfo.uid : null,
                            isForkModel : me.forkInformation.forkLatest,
                            content: null,
                            comment: me.comment,
                            forkedModelInfo: JSON.stringify(forkBy)
                        }
                    } else if (state == 'duplicate') {
                        obj = {
                            action: 'fork',
                            title: 'Duplicate',
                            projectName: proName,
                            editProjectName: JSON.parse(JSON.stringify(proName)),
                            userId:  me.forkInformation.forkLatest ? me.userInfo.uid : null,
                            isForkModel :  me.forkInformation.forkLatest,
                            content: null,
                            comment: me.comment
                        }
                    }
                    this.storageCondition = obj
                    this.storageDialog = true
                } else {
                    me.$EventBus.$emit('showLoginDialog')
                    alert("로그인 후에 이용이 가능합니다. 로그인 해주세요.")
                }

            },
            storageDialogCancel() {
                this.storageDialog = false
            },
            async backupModel() {
                var me = this
                try {
                    me.$refs['modeler-image-generator'].save(me.projectName, me.canvas).then(async function (img) {
                        var getProjectId = me.projectId
                        var newVersionId = await me.pushString(`db://definitions/${getProjectId}/versionLists`)
                        console.log('backup::', getProjectId)

                        var putInformation = {
                            lastVersionName: newVersionId,
                            img: img,
                            projectName: me.storageCondition.editProjectName,
                            // comment: me.storageCondition.comment
                        }
                        var putValue = {
                            value: JSON.stringify(me.value)
                        }
                        var putInfo = {
                            saveUser: me.userInfo.uid,
                            saveUserEmail: me.userInfo.email,
                            saveUserName: me.userInfo.name,
                            projectName: me.storageCondition.editProjectName,
                            img: img,
                            date: Date.now(),
                            comment: me.storageCondition.comment,
                        }

                        me.putObject(`db://definitions/${getProjectId}/information`, putInformation)
                        me.putObject(`db://definitions/${getProjectId}/versionLists/${newVersionId}/versionValue`, putValue)
                        me.putObject(`db://definitions/${getProjectId}/versionLists/${newVersionId}/versionInfo`, putInfo)

                        me.projectName = putInformation.projectName
                        me.storageDialogCancel()
                        alert('성공적으로 저장됨')
                    })
                } catch (e) {
                    me.alertInfo.text = 'BACKUP-ERROR' + e
                    me.alertInfo.show = true
                }
            },
            async saveModel() {
                var me = this

                try {
                    me.projectName = me.storageCondition.projectName
                    me.comment = me.storageCondition.comment

                    me.$refs['modeler-image-generator'].save(me.projectName, me.canvas).then(async function (img) {
                        var getProjectId = me.projectId ? me.projectId : me.dbuid()
                        var newVersionId = await me.pushString(`db://definitions/${getProjectId}/versionLists`)
                        console.log('save::', getProjectId, newVersionId)

                        var putInformation = {
                            author: me.userInfo.uid,
                            authorEmail: me.userInfo.email,
                            lastVersionName: newVersionId,
                            comment: me.comment,
                            date: Date.now(),
                            img: img,
                            lastModifiedDate: Date.now(),
                            lastModifiedUser: null,
                            lastModifiedEmail: null,
                            projectName: me.projectName,
                            type: me.canvasType,
                        }

                        var pushValue = {
                            value: JSON.stringify(me.value)
                        }

                        var pushSnap = {
                            lastSnapshotKey: '',
                            snapshot: JSON.stringify(me.value),
                            snapshotImg: img,
                            timeStamp: Date.now()
                        }

                        var putSpec = {specVersion: '3.0'}

                        var putUser = {
                            uid: me.userInfo.uid,
                            name: me.userInfo.name,
                            picture: me.userInfo.profile
                        }
                        var putProjectId = {
                            projectId: getProjectId,
                            lastModifiedDate: putInformation.lastModifiedDate,
                            type: putInformation.type,
                            img: putInformation.img,
                            projectName: putInformation.projectName
                        }

                        if (!me.isClazzModeling && me.isQueueModeling) {
                            me.pushObject(`db://definitions/${getProjectId}/snapshotLists`, pushSnap)
                            me.putObject(`db://definitions/${getProjectId}`, putSpec)
                        }

                        me.putObject(`db://definitions/${getProjectId}/information`, putInformation)
                        me.putObject(`db://userLists/${putUser.uid}`, putUser)

                        /* 백업용 사용자의 local에서 마지막 모델링 정보 */
                        me.putObject(`db://definitions/${getProjectId}/versionLists/${newVersionId}/versionValue`, pushValue)

                        me.projectName = putInformation.projectName
                        me.specVersion = '3.0'

                        if (!me.isClazzModeling) {
                            var lists = await me.getObject(`localstorage://localLists`)
                            var index = lists.findIndex(list => list.projectId == me.projectId)
                            var location = 'storming'

                            if (index != -1) {
                                await me.delete(`localstorage://${me.projectId}`)
                                if (me.canvasType == 'k8s') {
                                    location = 'kubernetes'
                                } else if (me.canvasType == 'bm') {
                                    location = 'business-model-canvas'
                                }  else if (me.canvasType == 'uml') {
                                    location = 'uml'
                                }

                                lists.splice(index, 1)
                                await me.putObject(`localstorage://localLists`, lists)

                                me.$router.push({path: `/${location}/${putUser.uid}/${getProjectId}`});
                            }
                        }

                        if (!me.isClazzModeling) {
                            me.updatePermission()
                            if (me.isQueueModeling) {
                                me.receiveQueue()
                            } else {
                                me.receiveValueSpecOne()
                            }
                        }

                        me.storageDialogCancel()
                    })
                } catch (e) {
                    me.alertInfo.text = 'SAVE-ERROR' + e
                    me.alertInfo.show = true
                }

            },
            async checkedForkModel(){
                var me = this
                if(me.isServerModeling){
                    if( me.forkInformation.forkLatest || me.isClazzModeling ){
                        me.saveComposition('fork', me.gitOrgName, me.gitRepoName)
                    }else{
                        me.forkModel()
                    }
                }else{
                    me.forkModel()
                }
            },
            updateClassModelingId(newProjectId){
                this.$emit('newProjectId',newProjectId);
            },
            async forkModel() {
                var me = this

                try {
                    me.$refs['modeler-image-generator'].save(me.projectName, me.canvas).then(async function (img) {
                        if (!me.isServerModeling) {
                            me.storageDialogCancel()
                            alert('준비중 입니다.')
                        } else {
                            var getProjectId = me.dbuid()
                            var newVersionId = await me.pushString(`db://definitions/${getProjectId}/versionLists`)
                            // var forkId = me.forkInformation.forkOrigin ? me.forkInformation.forkOrigin : me.projectId
                            var forkId = me.projectId

                            var putInfo = {
                                author: me.userInfo.uid,
                                authorEmail: me.userInfo.email,
                                forkOrigin: forkId,
                                lastVersionName: newVersionId,
                                comment: me.storageCondition ? me.storageCondition.comment : '',
                                date: Date.now(),
                                img: img,
                                lastModifiedDate: Date.now(),
                                lastModifiedUser: null,
                                lastModifiedEmail: null,
                                projectName: me.storageCondition ? me.storageCondition.editProjectName : me.projectName,
                                type: me.information.type,
                            }

                            var pushValue = {
                                value: JSON.stringify(me.value)
                            }

                            var pushSnap = {
                                lastSnapshotKey: '',
                                snapshot: JSON.stringify(me.value),
                                snapshotImg: img,
                                timeStamp: Date.now()
                            }

                            var putSpec = {specVersion: '3.0'}

                            var putUser = {
                                uid: me.userInfo.uid,
                                name: me.userInfo.name,
                                picture: me.userInfo.profile
                            }
                            var putProjectObj = {
                                projectId: getProjectId,
                                forkOrigin: forkId,
                            }


                            if ( me.isQueueModeling) {
                                me.pushObject(`db://definitions/${getProjectId}/snapshotLists`, pushSnap)
                                me.putObject(`db://definitions/${getProjectId}`, putSpec)
                            }

                            me.putObject(`db://definitions/${getProjectId}/information`, putInfo)
                            me.putObject(`db://userLists/${putUser.uid}`, putUser)
                            me.putObject(`db://userLists/${putUser.uid}/mine/${getProjectId}`, putProjectObj)
                            // Origin Model Setting
                            me.setString(`db://definitions/${putProjectObj.forkOrigin}/forkUserLists/${me.userInfo.uid}`, getProjectId)

                            /* 백업용 사용자의 local에서 마지막 모델링 정보 */
                            var result = await me.putObject(`db://definitions/${getProjectId}/versionLists/${newVersionId}/versionValue`, pushValue)

                            if(me.isClazzModeling){
                                me.updateClassModelingId(getProjectId);
                            }else{
                                var location = 'storming'
                                if (me.canvasType == 'k8s') {
                                    location = 'kubernetes'
                                } else if (me.canvasType == 'bm') {
                                    location = 'business-model-canvas'
                                } else if (me.canvasType == 'uml') {
                                    location = 'uml'
                                }
                                me.$router.push({path: `/${location}/${putUser.uid}/${getProjectId}`});
                                setTimeout(function () {
                                    window.location.reload(true)
                                }, 100)
                            }
                        }

                        me.storageDialogCancel()
                    })
                } catch (e) {
                    me.alertInfo.text = 'FORK-ERROR' + e
                    me.alertInfo.show = true
                }
            },
            updatePermission() {
                var me = this
                me.watch(`db://definitions/${me.projectId}/information`, function (information) {
                    if (information) {
                        me.isServerModel = true
                        me.settingPermission(information)
                    }
                })
            },
            async getSpecVersion() {
                var me = this
                var getItem = '1.0'
                return new Promise(async function (resolve) {
                    var getSpecVersion = await me.getString(`db://definitions/${me.projectId}/specVersion`)
                    if (getSpecVersion) {
                        getItem = getSpecVersion
                    }
                    resolve(getItem)
                })
            },
            async loadDefinition() {
                var me = this
                var loadedDefinition = null

                // Project ID CHECK
                me.projectId = me.isClazzModeling ? me.projectId : me.params.projectId

                // rtc
                me.rtcRoomId = `modelRtc_${me.projectId}`

                localStorage.setItem('projectId', me.projectId)

                if (me.projectId) {
                    var information = await me.list(`db://definitions/${me.projectId}/information`)
                    me.$EventBus.$emit('progressValue', true)

                    if (information) {
                        me.isServerModel = true

                        var forkLatest =  await me.list(`db://definitions/${me.projectId}/forkUserLists/${me.userInfo.uid}`)
                        me.forkInformation.forkLatest = forkLatest ? forkLatest : null
                        me.forkInformation.forkOrigin = information.forkOrigin ? information.forkOrigin : null
                    } else {
                        // 로컬 일때는 로딩바 해제
                        me.$EventBus.$emit('progressValue', false)
                    }


                    if (me.isServerModel) {
                        me.settingPermission(information)

                        await me.enterUser()
                        me.specVersion = await me.getSpecVersion()

                        if (me.alertInfo.fnNum == 1) {
                            // permission denied
                        } else {
                            if (me.specVersion == '1.0') {
                                loadedDefinition = await me.loadDefinitionVersion1()
                            } else if (me.specVersion == '2.0') {
                                loadedDefinition = await me.loadDefinitionVersion2()
                            } else {
                                loadedDefinition = await me.loadDefinitionVersion3orAbove()
                            }
                            console.log('specVersion:', me.specVersion, ' setSnapshot:', me.lastSnapshotKey, 'snapshotLastKey:', me.lastSnapQueueKey)

                        }
                    } else if( !me.isServerModel && !me.isClazzModeling ) {
                        me.isMineProject = true
                        loadedDefinition = await me.loadDefinitionLocal()
                    }

                    if (loadedDefinition) {
                        if (me.canvasType == 'es') {
                            me.value = me.migrate(loadedDefinition)
                        } else {
                            me.value = loadedDefinition
                        }

                    } else if (!me.value) {
                        me.value = {'elements': {}, 'relations': {}}
                        me.initLoad = true
                    }

                    var toppingList = await me.list(`db://definitions/${me.projectId}/information/prefferdToppings`)
                    me.$EventBus.$emit('prefferdToppings', toppingList)
                } else {
                    if (!me.value)
                        me.value = {'elements': {}, 'relations': {}}
                }

                if (!me.isServerModel) {
                    me.$nextTick(function () {
                        me.$EventBus.$emit('progressValue', false)
                        me.initLoad = true
                        console.log('# Done init load')
                    })
                }

            },
            loadDefinitionLocal() {
                var me = this

                return new Promise(async function (resolve, reject) {
                        me.readOnly = false
                        me.projectName = 'untitled'

                        var lists = await me.getObject(`localstorage://localLists`)
                        var value = await me.getObject(`localstorage://${me.projectId}`)


                        if (lists) {
                            var index = lists.findIndex(list => list.projectId == me.projectId)
                            if (index == -1) {
                                var obj = {
                                    author: me.userInfo.uid,
                                    authorEmail: me.userInfo.email,
                                    comment: "",
                                    date: Date.now(),
                                    lastModifiedDate: Date.now(),
                                    projectName: me.projectName,
                                    projectId: me.projectId,
                                    type: me.canvasType,
                                }
                                lists.push(obj)
                                me.putObject(`localstorage://localLists`, lists)
                            } else {
                                me.projectName = lists[index] ? lists[index].projectName : ''
                                me.information = lists[index] ? lists[index] : null
                            }
                        } else if (!lists && !me.isClazzModeling) {
                            lists = []
                            var obj = {
                                author: me.userInfo.uid,
                                authorEmail: me.userInfo.email,
                                comment: "",
                                date: Date.now(),
                                lastModifiedDate: Date.now(),
                                projectName: me.projectName,
                                projectId: me.projectId,
                                type: me.canvasType,
                            }
                            lists.push(obj)
                            me.putObject(`localstorage://localLists`, lists)
                        }

                        var resovleData = null
                        if (value) {
                            resovleData = value
                        } else if (me.value
                            && me.value.elements && typeof me.value.elements == 'object'
                            && me.value.relations && typeof me.value.relations == 'object') {
                            resovleData = me.value
                        } else {
                            resovleData = {'elements': {}, 'relations': {}}
                        }

                        resolve(resovleData)
                    }
                )

            },
            loadDefinitionVersion1() {
                var me = this
                return new Promise(async function (resolve, reject) {

                    var getValue = await me.getString(`db://definitions/${me.projectId}/versionLists/${me.information.lastVersionName}`)

                    if (getValue && getValue.versionValue) {
                        resolve(JSON.parse(getValue.versionValue.value))
                    } else {
                        resolve({'elements': {}, 'relations': {}})
                    }


                })
            },
            loadDefinitionVersion2() {
                var me = this

                return new Promise(async function (resolve, reject) {

                    var option = {
                        sort: "desc",
                        orderBy: null,
                        size: 1,
                        startAt: null,
                        endAt: null,
                    }


                    var snapshots = await me.list(`db://definitions/${me.projectId}/snapshotLists`, option)

                    if (snapshots) {
                        var snapshotObj = snapshots[0]
                        me.lastSnapshotKey = snapshotObj.key
                        me.lastSnapQueueKey = snapshotObj.lastSnapshotKey ? snapshotObj.lastSnapshotKey : ''
                        me.value = JSON.parse(snapshotObj.snapshot)
                    } else {
                        me.lastSnapQueueKey = ''
                        me.value = {definition: [], relation: []}
                    }

                    var queueOption = {
                        sort: null,
                        orderBy: null,
                        size: null,
                        startAt: me.lastSnapQueueKey,
                        endAt: null,
                    }

                    var queueLists = await me.list(`db://definitions/${me.projectId}/queue`, queueOption)

                    if (queueLists) {

                        Object.keys(queueLists).forEach(function (key) {
                            me.latestQueueKey = key
                            var snapValue = queueLists[key]

                            var action = snapValue.action ? snapValue.action : snapValue.state

                            if (!action.includes('user')) {
                                var obj = {
                                    childKey: key,
                                    childValue: snapValue
                                }

                                me.receivedQueueDrawElement(obj)
                            }
                        })

                        resolve(me.value)
                    } else {
                        resolve(me.value)
                    }
                })
            },
            loadDefinitionVersion3orAbove() {
                var me = this
                return new Promise(async function (resolve, reject) {

                    var option = {
                        sort: "desc",
                        orderBy: null,
                        size: 1,
                        startAt: null,
                        endAt: null,

                    }
                    var snapshots = await me.list(`db://definitions/${me.projectId}/snapshotLists`, option)

                    if (snapshots) {
                        var snapshotObj = snapshots[0]
                        me.lastSnapshotKey = snapshotObj.key
                        me.lastSnapQueueKey = snapshotObj.lastSnapshotKey ? snapshotObj.lastSnapshotKey : ''
                        var tmp = JSON.parse(snapshotObj.snapshot)
                        var tmpKeys = Object.keys(tmp.elements)
                        tmpKeys.forEach(function (elementKey) {
                            var element = tmp.elements[elementKey]
                            if (element) {
                                if (element._type == 'org.uengine.modeling.model.BoundedContext') {
                                    if (!element.preferredPlatform) element.preferredPlatform = null
                                    if (!element.members) element.members = null
                                }
                                if (!element.rotateStatus) {
                                    element.rotateStatus = false
                                }
                            }
                        })
                        resolve(tmp)
                    } else {
                        me.lastSnapQueueKey = ''
                        resolve({'elements': {}, 'relations': {}})
                    }


                })
            },
            migrate(value) {
                var me = this

                value = me.migrate1To2(value)
                value = me.migrate2To3(value)
                value = me.migrateAddAttr(value)
                value = me.modelMigrate(value)

                return value

            },
            migrate1To2(value) {
                var me = this

                if (me.specVersion != '3.0' && !value.version) {
                    if (!value.relations) value.relations = {}
                    if (!value.elements) value.elements = {}

                    Object.keys(value).forEach(function (key, index) {
                        if (Array.isArray(value[key])) {
                            if (key.includes('relation')) {
                                Object.values(value[key]).forEach(function (relation, index) {
                                    if (relation)
                                        me.$set(value.relations, relation.relationView.id, relation)
                                })
                            } else if (key.includes('definition')) {
                                Object.values(value[key]).forEach(function (element, index) {
                                    if (element)
                                        me.$set(value.elements, element.elementView.id, element)
                                })
                            }
                        }
                    })
                    value.version = 3
                    console.log('load 1 to3')
                }
                delete value['definition'];
                delete value['relation'];


                return value

            },
            migrate2To3(value) {
                var me = this

                // if (me.storageExist && me.specVersion != '3.0' && me.paramKeys.indexOf('classId') == -1) {
                if (me.isServerModeling && !me.isClazzModeling && me.specVersion != '3.0') {
                    me.$refs['modeler-image-generator'].save(me.projectName, me.canvas).then(async function (resolve) {

                        var pushObj = {
                            snapshot: JSON.stringify(value),
                            timeStamp: Date.now(),
                            snapshotImg: resolve,
                            lastSnapshotKey: '',
                        }
                        var putObj = {
                            specVersion: '3.0'
                        }

                        await me.pushObject(`db://definitions/${me.projectId}/snapshotLists`, pushObj)
                        await me.delete(`db://definitions/${me.projectId}/queue`)
                        await me.putObject(`db://definitions/${me.projectId}`, putObj)
                        setTimeout(function () {
                            me.specVersion = '3.0'
                            window.location.reload(true)
                            console.log('load 2 to3')
                        }, 500);
                    })

                }
                return value
            },
            migrateAddAttr(value) {
                //Setting added Entity ( By Local migrate)
                if (value.elements) {
                    Object.values(value.elements).forEach(function (element) {
                        if (element && !element.description) {
                            element.description = null
                        }
                    })
                }
                if (value.relations) {
                }

                return value
            },
            modelMigrate(value){
              return  value
            },
            requestInviteUser() {
                var me = this
                //login check
                try {
                    me.setUserInfo()
                    if (me.isLogin) {
                        if (me.information.permissions &&
                            me.information.permissions[me.userInfo.uid] &&
                            me.information.permissions[me.userInfo.uid].request) {
                            alert('권한 요청된 상태입니다.')
                        } else {
                            var obj = {
                                email: me.userInfo.email,
                                permission: "Write",
                                request: true,
                            }
                            me.applyInviteUsers(obj, true)
                        }

                    } else {
                        me.$EventBus.$emit('showLoginDialog')
                    }

                } catch (e) {
                    alert('Error: request - inviteUser :', e)
                }

            },
            async openInviteUsers() {
                var me = this
                var getPermission = await me._get(`db://definitions/${me.projectId}/information/permissions`)
                me.invitationLists = getPermission
                if (me.invitationLists) {
                    me.showPublicModel = Object.keys(me.invitationLists).indexOf('everyone') == -1 ? false : true
                }

                me.inviteDialog = true
            },
            invitePublic(show) {
                var me = this
                if (!me.invitationLists) me.invitationLists = {}

                if (show) {
                    me.invitationLists['everyone'] = {
                        uid: 'everyone',
                        userName: 'Everyone',
                        write: false,
                    }
                    me.showPublicModel = true
                } else {
                    me.invitationLists['everyone'] = null
                    me.showPublicModel = false
                }

            },
            getPodStatus(userName, userGroup, projectName) {
                var me = this
                return new Promise(function (resolve, reject) {
                    var hashName;
                    if (me.$route.params.labId) {
                        if (me.$parent.labInfo.independent) {
                            var hashPath = me.getClassPath('labs/' + me.$route.params.labId + '/' + me.$route.params.userId);
                        } else {
                            var hashPath = me.getClassPath(me.$route.params.userId);
                        }
                        hashName = "labs-" + me.hashCode(hashPath);
                    } else {
                        hashName = `ide-${me.hashCode(userGroup + "-" + userName)}`
                    }
                    me.$http.get(`${me.getProtocol()}//api.${me.getTenantId()}/api/v1/namespaces/default/pods/${hashName}`).then(function (result) {
                        if (result.data.status.phase == "Running") {
                            resolve(true)
                        } else {
                            resolve(false)
                        }
                    }).catch(function (e) {
                        resolve(false)
                    })
                })
            },
            checkIdeOperator(hashName) {
                var me = this
                if (me.$parent.classInfo) {
                    var serverToken = me.$parent.classInfo.token;
                    var serverUrl = me.$parent.classInfo.serverUrl;
                }

                if (!serverUrl || !serverToken) {
                    return new Promise(function (resolve) {
                        me.$http.get(`${me.getProtocol()}//api.${me.getTenantId()}/apis/uengine.org/v1alpha1/namespaces/default/ides/${hashName}/status`).then(function (result) {
                            console.log(result.data.status.conditions)
                            result.data.status.conditions.forEach(function (item) {
                                if (item.reason == "InstallSuccessful" && item.type == "Deployed") {
                                    resolve(true)
                                }
                            })
                        }).catch(function (e) {
                            resolve(false)
                        })
                    })
                } else {
                    return new Promise(function (resolve) {
                        me.$http.get(`http://api.${me.getTenantId()}/apis/uengine.org/v1alpha1/namespaces/default/ides/${hashName}/status?serverUrl=${serverUrl}&token=${serverToken}`).then(function (result) {
                            console.log(result.data.status.conditions)
                            result.data.status.conditions.forEach(function (item) {
                                if (item.reason == "InstallSuccessful" && item.type == "Deployed") {
                                    resolve(true)
                                }
                            })
                        }).catch(function (e) {
                            resolve(false)
                        })
                    })
                }
            },
            deleteConfig(hashName, obj) {
                var me = this
                return new Promise(async function (resolve, reject) {
                    var tenant;
                    if(me.$parent.classInfo) {
                        tenant = me.$parent.classInfo.ideUrl
                    } else {
                        tenant = window.MODE == "onprem" ? me.getTenantId() : 'kuberez.io'
                    }
                    me.$http.delete(`${me.getProtocol()}//file.${tenant}/api/deleteConfig`, {
                        data: {
                            "tenant": "eventstorming",
                            "course": obj.course,
                            "clazz": "users",
                            "userId": obj.userId,
                            "status": "running",
                            "hashName": hashName
                        }
                    }, {
                        headers: {
                            "Content-Type": "application/json; charset=UTF-8"
                        }
                    }).then(function () {
                        resolve()
                    }).catch(error => alert(error))
                    // await me.putObject(configPath + '/config', configJson)
                    // resolve()
                })
            },
            makeDir(path) {
                var me = this;
              return new Promise(function (resolve,reject) {
                  var tenant;
                    if(me.$parent.classInfo) {
                        tenant = me.$parent.classInfo.ideUrl
                    } else {
                        tenant = window.MODE == "onprem" ? me.getTenantId() : 'kuberez.io'
                    }
                  me.$http.post(`${me.getProtocol()}//file.${tenant}/api/makeDir`, {
                        "path": path
                    }).then(function () {
                        return resolve();
                  }).catch(function(e) {
                        alert(e);
                      reject();
                  });
              })
            },
            makeConfig(hashName, obj) {
                var me = this
                return new Promise(async function (resolve, reject) {
                    var serverUrl, serverToken, ideUrl;
                    if (me.$parent.classInfo) {
                        serverUrl = me.$parent.classInfo.serverUrl;
                        serverToken = me.$parent.classInfo.token;
                    } else {
                        serverUrl = window.MODE == "onprem" ? window.CLUSTER_ADDRESS : 'https://218.236.22.12:6443';
                    }

                    var serviceAccount = await me.existServiceAccountCheck(hashName);

                    function sleep(ms) {
                        return new Promise(resolve => setTimeout(resolve, ms))
                    }

                    while (!serviceAccount) {
                        serviceAccount = await me.existServiceAccountCheck(hashName);
                        await sleep(3000)
                    }

                    var secretName = serviceAccount.data.secrets[0].name
                    var secret = await me.getSecret(hashName, secretName);

                    while (!secret) {
                        secret = await me.getSecret(hashName, secretName)
                        await sleep(3000)
                    }

                    var decodedToken = atob(secret);

                    // 6. upload Config
                    // 클러스터명, 서버ip 바꿔줄 것!

                    var configJson = {
                        "apiVersion": "v1",
                        "clusters": [
                            {
                                "cluster": {
                                    "insecure-skip-tls-verify": true,
                                    "server": serverUrl
                                },
                                "name": "kcb-test2.k8s.local"
                            }
                        ],
                        "contexts": [
                            {
                                "context": {
                                    "cluster": "kcb-test2.k8s.local",
                                    "namespace": hashName,
                                    "user": hashName
                                },
                                "name": "kcb-test2.k8s.local"
                            }
                        ],
                        "current-context": "kcb-test2.k8s.local",
                        "kind": "Config",
                        "preferences": {},
                        "users": [
                            {
                                "name": hashName,
                                "user": {
                                    "token": decodedToken
                                }
                            }
                        ]
                    }
                    var tenant;
                    if(me.$parent.classInfo) {
                        tenant = me.$parent.classInfo.ideUrl
                    } else {
                        tenant = window.MODE == "onprem" ? me.getTenantId() : 'kuberez.io'
                    }
                    me.$http.post(`${me.getProtocol()}//file.${tenant}/api/uploadConfig`, {
                        "config": JSON.stringify(configJson),
                        "tenant": me.$route.params.labId ? me.getTenantId() : "eventstorming",
                        "course": obj.course,
                        "clazz": me.$route.params.labId ? obj.clazz : `users`,
                        "userId": obj.userId,
                        "status": "running",
                        "hashName": hashName
                    }, {
                        headers: {
                            "Content-Type": "application/json; charset=UTF-8"
                        }
                    }).then(function () {
                        me.$EventBus.$emit("nextStep")
                        resolve()
                    }).catch(error => alert(error))
                    // await me.putObject(configPath + '/config', configJson)
                    // resolve()
                })
            },
            async addInviteUser(user) {
                var me = this
                var write = false
                var success = false
                if (user.email) {
                    return new Promise(async function (resolve, reject) {
                        if (user.permission == 'Write') {
                            write = true
                        }

                        var options = {
                            sort: "desc",
                            orderBy: 'email',
                            size: null,
                            startAt: `${user.email}`,
                            endAt: `${user.email}`,
                        }

                        var snapshots = await me.list('db://users',options)
                        if(snapshots){
                            snapshots.forEach(function (snapshot) {
                                var uid = snapshot.key
                                if( (Object.keys(snapshots).length == 1) || (Object.keys(snapshots).length > 1 && me.userInfo.uid == uid) ){
                                    var item = snapshot
                                    if (!me.invitationLists) me.invitationLists = {}
                                    me.invitationLists[uid] =
                                        {
                                            uid: uid,
                                            userName: item.userName ? item.userName : ( item.username ? item.username : 'anyone'),
                                            userPic: item.profile_picture ? item.profile_picture : '',
                                            email: item.email ? item.email : user.email,
                                            write: write,
                                            request: user.request ? user.request : null
                                        }
                                }
                            })
                            me.invitationLists.__ob__.dep.notify()
                            if(!me.invitationLists){
                                var obj = {
                                    msg: "공유실패: Can't find user. check email."
                                }
                                me.$EventBus.$emit('inviteCallBack', obj)
                                // me.snackbar.show = true
                                // me.snackbar.text = "공유실패: Can't find user. check email."
                                // me.snackbar.color = '#E57373'
                                resolve(false)
                            }
                            resolve(true)
                        }else{
                            var obj = {
                                msg: "공유실패: 초대하려는 유저가 구글 로그인을 안했을 가능성이 높습니다."
                            }
                            me.$EventBus.$emit('inviteCallBack', obj)
                            // me.snackbar.show = true
                            // me.snackbar.text = '공유실패: 초대하려는 유저가 구글 로그인을 안했을 가능성이 높습니다.'
                            // me.snackbar.color = '#E57373'
                            resolve(false)
                        }
                    })
                } else {
                    var obj = {
                        msg: "공유실패: 이메일형식에 맞춰서 넣어주세요."
                    }
                    me.$EventBus.$emit('inviteCallBack', obj)
                    // me.snackbar.show = true
                    // me.snackbar.text = '공유실패: 이메일형식에 맞춰서 넣어주세요.'
                    // me.snackbar.color = '#E57373'
                    resolve(false)
                }
            },
            removeInviteUser(user) {
                var me = this
                me.invitationLists[user.uid] = null
                if (user.uid == 'everyone') {
                    me.showPublicModel = false
                }
                me.invitationLists.__ob__.dep.notify();
            },
            async applyInviteUsers(inputUser, request) {
                var me = this
                var result = true
                if (inputUser) {
                    result = await me.addInviteUser(inputUser)
                }
                console.log(me.invitationLists)

                if (me.invitationLists) {
                    if (!request) {
                        Object.keys(me.invitationLists).forEach(function (invitation) {
                            if (me.invitationLists[invitation] && me.invitationLists[invitation].request) {
                                me.invitationLists[invitation].request = false
                            }
                        })
                    }

                    me.putObject(`db://definitions/${me.projectId}/information/permissions`, me.invitationLists)
                    me.information.permissions = me.invitationLists
                    me.changed = true
                    if (request) {
                        me.joinRequested = true
                    }
                }

                if (result) {
                    var obj = {
                        msg: null
                    }
                    me.$EventBus.$emit('inviteCallBack', obj)
                    me.inviteDialog = false
                }

            },
            closeInviteUsers(beforeInvitationLists) {
                var me = this
                console.log(beforeInvitationLists)
                if (beforeInvitationLists) {
                    Object.keys(beforeInvitationLists).forEach(function (invitation) {
                        if (beforeInvitationLists[invitation] && beforeInvitationLists[invitation].request) {
                            beforeInvitationLists[invitation].request = false
                        }
                    })
                    me.putObject(`db://definitions/${me.projectId}/information/permissions`, beforeInvitationLists)
                    me.information.permissions = beforeInvitationLists
                    me.changed = false
                }
                me.inviteDialog = false
            },
            getLastQueue() {
                var me = this
                return new Promise(async function (resolve, reject) {
                    var option = {
                        sort: 'desc',
                        orderBy: null,
                        size: 2,
                        startAt: null,
                        endAt: null,
                    }

                    var result = await me.list(`db://definitions/${me.projectId}/queue`, option)
                    resolve(result)
                })
            },
            getUndoRedoQueue(endAt) {
                var me = this
                return new Promise(async function (resolve) {
                    var option = {
                        sort: 'desc',
                        orderBy: null,
                        size: 2,
                        startAt: null,
                        endAt: endAt,
                    }
                    var keyValue = await me.list(`db://definitions/${me.projectId}/queue`, option)

                    if (keyValue) {
                        var prevVal = keyValue[0]
                        var prevKey = prevVal.key
                        var nextVal = keyValue[1]
                        var nextKey = nextVal ? nextVal.key : null

                        if (prevKey && prevVal.action.includes('user')) {
                            resolve(me.getUndoRedoQueue(nextKey))
                        } else {
                            resolve(keyValue)
                        }
                    } else {
                        resolve(null)
                    }
                })
            },
            sort(lastChild, lastChildIndex) {
                var me = this
                var currentChild = null

                if (me.sortScheduleId) return;
                try {

                    if (lastChild == null) {
                        lastChildIndex = queueFifo.elements.length - 1;
                        lastChild = queueFifo.elements[lastChildIndex];
                    }
                    var timePassed = Date.now() - lastChild.childValue.receivedTime;
                    if (timePassed < 200 || me.changedByMe) {

                        if (!me.sortScheduleId) {
                            me.sortScheduleId =
                                setTimeout(function () {
                                        me.sortScheduleId = null
                                        me.sort(lastChild, lastChildIndex);
                                    },
                                    300
                                );
                        }
                    } else {
                        /* receivedQueue Start */
                        me.$EventBus.$emit('progressValue', true)

                        var countOrdered = lastChildIndex + 1;

                        queueFifo.elements.sort(function (a, b) { // 오름순
                            return a.childKey < b.childKey ? -1 : a.childKey > b.childKey ? 1 : 0;
                        });

                        for (var i = 0; i < countOrdered; i++) {
                            currentChild = queueFifo.elements[i]
                            me.receivedQueueItemCountAfterLastSnapshot = me.receivedQueueItemCountAfterLastSnapshot + 1
                            me.receivedQueueDrawElement(queueFifo.elements[i])
                        }
                        for (var i = 0; i < countOrdered; i++) {
                            var firstQueue = queueFifo.dequeue()
                            currentChild = null

                            if (firstQueue &&
                                firstQueue.childValue.editUid == me.userInfo.uid &&
                                me.receivedQueueItemCountAfterLastSnapshot >= me.snapshotFrequency &&
                                me.receivedQueueItemCountAfterLastSnapshot % me.snapshotFrequency == 0) {
                                me.checkLeaderExist(firstQueue)
                            }

                        }

                        if (queueFifo.isEmpty()) {
                            /* receivedQeue End */
                            me.$EventBus.$emit('progressValue', false)
                            me.$nextTick(function () {
                                me.overlayText = null
                                me.initLoad = true
                                console.log('#---------  End received Queue ----------------#')
                                if(me.isAutoForkModel){
                                    me.autoForkModel()
                                }
                            })
                        }

                        lastChildIndex = queueFifo.elements.length - 1;
                        lastChild = queueFifo.elements[lastChildIndex];

                        if (lastChildIndex > -1) {
                            me.sortScheduleId =
                                setTimeout(function () {
                                        me.sortScheduleId = null
                                        me.sort(lastChild, lastChildIndex);
                                    },
                                    300
                                );
                        }


                    }

                } catch (e) {
                    console.log('sortError: ', e, 'lastChild:', lastChild, 'key:', lastChild.childKey, 'action:', lastChild.childValue.action , currentChild)

                    me.watch_off(`db://definitions/${me.projectId}/queue`)
                    if( currentChild && currentChild.childKey ){
                        me.delete(`db://definitions/${me.projectId}/queue/${currentChild.childKey}`)
                    }
                    var queueIds = queueFifo.findIndexByChildKey(currentChild.childKey)
                    if(queueIds != -1){
                        queueFifo.removeByIndex(queueIds)
                    }
                    me.$emit('forceUpdateKey')
                }


            },
            async checkLeaderExist(child) {
                var me = this
                var lastKey

                var option = {
                    sort: 'desc',
                    orderBy: null,
                    size: 1,
                    startAt: null,
                    endAt: null,
                }

                var snapshot = await me.list(`db://definitions/${me.projectId}/snapshotLists`, option)

                if (snapshot) {
                    var snapshotObj = snapshot[0]
                    lastKey = snapshotObj.lastSnapshotKey ? snapshotObj.lastSnapshotKey : ''
                }

                if (!snapshot || lastKey < child.childKey) {
                    me.$refs['modeler-image-generator'].save(me.id, me.canvas).then(function (resolve) {

                        var obj = {
                            snapshot: JSON.stringify(me.value),
                            timeStamp: Date.now(),
                            snapshotImg: resolve,
                            lastSnapshotKey: child.childKey,
                        }
                        me.pushObject(`db://definitions/${me.projectId}/snapshotLists`, obj)
                    })
                }

                me.receivedQueueItemCountAfterLastSnapshot = 0

            },
            undoRedoDraw(child, state) {
                var me = this

                var action = child.childValue.action ? child.childValue.action : child.childValue.state

                if (state == 'undo') {
                    if (action == 'redo') {
                        child = JSON.parse(child.childValue.item)
                        action = child.childValue.action
                    }

                    if (action.includes('Move')) {
                        var orgin = JSON.parse(JSON.stringify(child.childValue.after))
                        child.childValue.after = child.childValue.before
                        child.childValue.before = orgin
                    } else if (action.includes('Modify')) {
                        child.childValue.item = JSON.stringify(jsondiffpatch.reverse(JSON.parse(child.childValue.item)))
                    } else if (action.includes('Push')) {
                        child.childValue.action = child.childValue.action.replace('Push', 'Delete')
                    } else if (action.includes('Delete')) {
                        child.childValue.action = child.childValue.action.replace('Delete', 'Push')
                    }

                } else if (state == 'redo') {
                    child = JSON.parse(child.childValue.item)

                    if (action == 'undo') {
                        action = child.childValue.action
                        if (action.includes('Move')) {
                            var orgin = JSON.parse(JSON.stringify(child.childValue.after))
                            child.childValue.after = child.childValue.before
                            child.childValue.before = orgin
                        } else if (action.includes('Modify')) {
                            child.childValue.item = JSON.stringify(jsondiffpatch.reverse(JSON.parse(child.childValue.item)))
                        } else if (action.includes('Push')) {
                            child.childValue.action = child.childValue.action.replace('Push', 'Delete')
                        } else if (action.includes('Delete')) {
                            child.childValue.action = child.childValue.action.replace('Delete', 'Push')
                        }
                    }

                }

                var obj = {
                    action: state,
                    editUid: me.userInfo.uid,
                    timeStamp: Date.now(),
                    item: JSON.stringify(child)
                }
                me.pushObject(`db://definitions/${me.projectId}/queue`, obj)

            },
            receivedQueueDrawElement(child, ignore) {
                var me = this
                ignore = ignore ? ignore : false

                if (child != undefined) {
                    var item = null
                    var afterMove = null
                    var action = child.childValue.action ? child.childValue.action : child.childValue.state

                    if (action == 'undo' || action == 'redo') {
                        // changedByMe
                        ignore = true
                        child = JSON.parse(child.childValue.item)
                        action = child.childValue.action
                    }

                    if (action.includes('Move')) {
                        afterMove = child.childValue.after
                    } else {
                        item = child.childValue.item ? JSON.parse(child.childValue.item) : null
                    }

                    //origin
                    if (action == 'elementPush') {

                        if (me.specVersion == '2.0') {

                            if (me.value.elements) {
                                me.$set(me.value.elements, item.elementView.id, item)
                            } else if (me.value.definition) {
                                me.value.definition.push(item)
                            }

                        } else {
                            if (!ignore && child.childKey < me.prevKey) {
                                console.log('Wrong Order: elementPush ', child.childKey, 'prevKey:', me.prevKey, child)

                                me.watch_off(`db://definitions/${me.projectId}/queue`)
                                if( child && child.childKey ){
                                    me.delete(`db://definitions/${me.projectId}/queue/${child.childKey}`)
                                }
                                var queueIds = queueFifo.findIndexByChildKey(child.childKey)
                                if(queueIds != -1){
                                    queueFifo.removeByIndex(queueIds)
                                }
                                me.$emit('forceUpdateKey')
                            }
                            if (ignore || child.childKey != me.prevKey) {
                                me.prevKey = child.childKey
                                //Setting added Entity ( By Queue migrate)
                                if (!item._type.endsWith('Relation')) {
                                    if (!item.description) {
                                        item.description = null
                                    }
                                    item.author = child.childValue.editUid
                                    item.rotateStatus = false
                                }
                                if (item._type.endsWith('BoundedContext')) {
                                    if (!item.preferredPlatform) item.preferredPlatform = null
                                }
                                if (item._type.endsWith('BoundedContext')) {
                                    if (!item.members) item.members = []
                                }

                                //add Element
                                me.$set(me.value.elements, item.elementView.id, item)

                                if (me.initLoad) {
                                    me.changedTemplateCode = true
                                }
                                me.$nextTick(function () {
                                    //STATUS_COMPLETE_addElementPush
                                    me.$EventBus.$emit(`${item.elementView.id}`, {
                                        action: action,
                                        STATUS_COMPLETE: true
                                    })
                                })

                            } else {
                                console.log('reduplication Element Push')
                            }

                        }

                    } else if (action == 'elementDelete') {
                        try {

                            if (me.specVersion == '2.0') {
                                var obj = {
                                    action: 'delete',
                                    element: JSON.stringify(item)
                                }
                                me.$nextTick(function () {
                                    me.$EventBus.$emit(`${item.elementView.id}`, obj)
                                })
                            } else {
                                me.value.elements[item.elementView.id] = null;

                                if (me.initLoad) {
                                    me.changedTemplateCode = true
                                }

                                // Changed Status
                                me.$nextTick(function () {
                                    //STATUS_COMPLETE_elementDelete
                                    me.$EventBus.$emit(`${item.elementView.id}`, {
                                        action: action,
                                        STATUS_COMPLETE: true
                                    })
                                })
                            }

                        } catch (e) {
                            console.log('Wrong Order', 'now', child.childKey, 'prev:', me.prevKey, child)

                            me.watch_off(`db://definitions/${me.projectId}/queue`)
                            if( child && child.childKey ){
                                me.delete(`db://definitions/${me.projectId}/queue/${child.childKey}`)
                            }
                            var queueIds = queueFifo.findIndexByChildKey(child.childKey)
                            if(queueIds != -1){
                                queueFifo.removeByIndex(queueIds)
                            }
                            me.$emit('forceUpdateKey')
                        }

                    } else if (action == 'elementMove') {

                        try {
                            var elementId = child.childValue.elementId
                            var isHexagonal = child.childValue && child.childValue.isHexagonal ? true : false

                            var obj = {
                                action: 'elementMove',
                                element: afterMove,
                            }

                            me.onMoveElementById(elementId, afterMove, isHexagonal)

                            // Changed Status
                            me.$nextTick(function () {
                                me.$EventBus.$emit(`${elementId}`, {action: action})
                            })


                        } catch (e) {
                            console.log('Wrong Order', 'now', child.childKey, 'prev:', me.prevKey, child)

                            me.watch_off(`db://definitions/${me.projectId}/queue`)
                            if( child && child.childKey ){
                                me.delete(`db://definitions/${me.projectId}/queue/${child.childKey}`)
                            }
                            var queueIds = queueFifo.findIndexByChildKey(child.childKey)
                            if(queueIds != -1){
                                queueFifo.removeByIndex(queueIds)
                            }
                            me.$emit('forceUpdateKey')
                        }


                    } else if (action == 'valueModify') {
                        try {
                            //changedByMe
                            if (!ignore && me.changedByMeKeys.includes(child.childKey)) {
                                me.changedByMeKeys.splice(me.changedByMeKeys.indexOf(child.childKey), 1)
                                if (me.initLoad) {
                                    me.changedTemplateCode = true
                                }

                            } else {
                                jsondiffpatch.patch(me.value, item)

                                if (me.initLoad) {
                                    me.changedTemplateCode = true
                                }
                            }

                        } catch (e) {
                            try {
                                //null value ignore
                                var location = Object.keys(item)[0]
                                var itemKey = Object.keys(item[location])[0]
                                if (me.value[location][itemKey]) {
                                    jsondiffpatch.patch(me.value, item)
                                }
                            } catch (e) {
                                console.log('patchError:', e, child.childKey, JSON.parse(JSON.stringify(me.value)), JSON.parse(child.childValue.item))
                                me.watch_off(`db://definitions/${me.projectId}/queue`)
                                if( child && child.childKey ){
                                    me.delete(`db://definitions/${me.projectId}/queue/${child.childKey}`)
                                }
                                var queueIds = queueFifo.findIndexByChildKey(child.childKey)
                                if(queueIds != -1){
                                    queueFifo.removeByIndex(queueIds)
                                }
                                me.$emit('forceUpdateKey')
                            }

                        }

                    } else if (action == 'relationPush') {

                        // var item = JSON.parse(child.childValue.item)
                        if (me.specVersion == '2.0') {

                            if (me.value.relations) {
                                me.$set(me.value.relations, item.relationView.id, item)
                            } else if (me.value.relation) {
                                me.value.relation.push(item);
                            }

                        } else {
                            if (!ignore && child.childKey < me.prevKey) {
                                console.log('Wrong Order', 'now', child.childKey, 'prev:', me.prevKey, child)

                                me.watch_off(`db://definitions/${me.projectId}/queue`)
                                if( child && child.childKey ){
                                    me.delete(`db://definitions/${me.projectId}/queue/${child.childKey}`)
                                }
                                var queueIds = queueFifo.findIndexByChildKey(child.childKey)
                                if(queueIds != -1){
                                    queueFifo.removeByIndex(queueIds)
                                }
                                me.$emit('forceUpdateKey')
                            }

                            if (ignore || child.childKey != me.prevKey) {
                                me.prevKey = child.childKey

                                if (me.validateRelation(item.from, item.to)) {

                                    if (!item._type.endsWith('Relation')) {
                                        item.author = child.childValue.editUid
                                    }

                                    me.$set(me.value.relations, item.relationView.id, item)

                                    if (me.initLoad) {
                                        me.changedTemplateCode = true
                                    }

                                    me.$nextTick(function () {
                                        //STATUS_COMPLETE_addElementPush
                                        me.$EventBus.$emit(`${item.relationView.id}`, {
                                            action: action,
                                            STATUS_COMPLETE: true
                                        })
                                    })
                                }


                            } else {
                                console.log('reduplication Relation Push')
                            }
                        }


                    } else if (action == 'relationDelete') {

                        try {
                            if (me.specVersion == '2.0') {
                                var obj = {
                                    action: 'delete',
                                    element: JSON.stringify(item)
                                }
                                me.$nextTick(function () {
                                    me.$EventBus.$emit(`${item.relationView.id}`, obj)
                                })
                            } else {
                                me.value.relations[item.relationView.id] = null;

                                if (me.initLoad) {
                                    me.changedTemplateCode = true
                                }

                                me.$nextTick(function () {
                                    //STATUS_COMPLETE_relationDelete
                                    me.$EventBus.$emit(`${item.relationView.id}`, {
                                        action: action,
                                        STATUS_COMPLETE: true
                                    })
                                })

                            }
                        } catch (e) {
                            console.log('Wrong Order', 'now', child.childKey, 'prev:', me.prevKey, child)

                            me.watch_off(`db://definitions/${me.projectId}/queue`)
                            if( child && child.childKey ){
                                me.delete(`db://definitions/${me.projectId}/queue/${child.childKey}`)
                            }
                            var queueIds = queueFifo.findIndexByChildKey(child.childKey)
                            if(queueIds != -1){
                                queueFifo.removeByIndex(queueIds)
                            }
                            me.$emit('forceUpdateKey')
                        }


                    } else if (action == 'relationMove') {

                        try {
                            var relatinId = child.childValue.relationId
                            var isHexagonal = child.childValue && child.childValue.isHexagonal ? true : false

                            var obj = {
                                action: 'relationMove',
                                element: afterMove
                            }

                            me.onMoveRelationById(relatinId, afterMove, isHexagonal)

                            me.$nextTick(function () {
                                me.$EventBus.$emit(`${relatinId}`, obj)
                            })

                        } catch (e) {
                            console.log('Wrong Order', 'now', child.childKey, 'prev:', me.prevKey, child)

                            me.watch_off(`db://definitions/${me.projectId}/queue`)
                            if( child && child.childKey ){
                                me.delete(`db://definitions/${me.projectId}/queue/${child.childKey}`)
                            }
                            var queueIds = queueFifo.findIndexByChildKey(child.childKey)
                            if(queueIds != -1){
                                queueFifo.removeByIndex(queueIds)
                            }
                            me.$emit('forceUpdateKey')
                        }
                    }
                }
            },
            async receiveValueSpecOne() {
                var me = this
                await me.watch(`db://definitions/${me.projectId}/versionLists/${me.information.lastVersionName}/versionValue`, function (callback) {
                    // me.changedByMe = false
                    me.value = JSON.parse(callback.value)
                })
            },
            receiveQueue() {
                var me = this
                var isWaitingQueue = null
                isWaitingQueue = setTimeout(function () {
                    /* receivedQeue End */
                    me.initLoad = true
                    me.$EventBus.$emit('progressValue', false)
                    if(me.isAutoForkModel){
                        me.autoForkModel()
                    }
                },3000)


                var options = {
                    sort: null,
                    orderBy: null,
                    size: null,
                    startAt: me.lastSnapQueueKey,
                    endAt: null,
                }

                me.watch_added(`db://definitions/${me.projectId}/queue`, options, function (queue) {
                    // console.log('watch_added:: ', queue)
                    // console.log('receiveQueue: ', queue.key, me.lastSanpQueueKey, queue.key > me.lastSnapQueueKey)
                    if (queue) {
                        me.latestQueueKey = queue.key
                    }
                    if (me.specVersion != '1.0' && queue && (me.lastSnapQueueKey ? queue.key > me.lastSnapQueueKey : true)) {
                        if (queue.action == 'userEntrance') {

                            var obj = {
                                uid: queue.editUid,
                                email: queue.email,
                                userName: queue.userName,
                                picture: queue.picture
                            }
                            if (me.participantLists.findIndex(user => user.uid == obj.uid) == -1) {
                                me.participantLists.push(obj)
                            }

                        } else if (queue.action == 'userExit') {
                            var obj = {
                                uid: queue.editUid,
                                email: queue.email,
                                userName: queue.userName,
                            }
                            var findIndex = me.participantLists.findIndex(user => user.uid == obj.uid)
                            if (findIndex != -1) {
                                me.participantLists.splice(findIndex, 1)
                            }

                        } else if (queue.action == 'userPanelOpen' ||
                            queue.action == 'userPanelClose' ||
                            queue.action == 'userSelectedOn' ||
                            queue.action == 'userSelectedOff' ||
                            queue.action == 'userMovedOn' ||
                            queue.action == 'userMovedOff') {

                            var obj = {
                                action: queue.action,
                                uid: queue.editUid,
                                picture: queue.picture,
                                name: queue.name
                            }

                            me.$EventBus.$emit(`${queue.editElement}`, obj)

                        } else {
                            clearTimeout(isWaitingQueue)

                            if (!me.receivedQueueExistValue) {
                                me.receivedQueueExistValue = true
                            }

                            var obj = {
                                _ordered: false,
                                childKey: queue.key,
                                childValue: queue
                            }
                            obj.childValue.key = queue.key;
                            obj.childValue.receivedTime = Date.now();

                            queueFifo.enqueue(obj)
                            me.sort();
                        }
                    }


                })
            },
            async modifiedElement(diff) {
                var me = this
                // console.log("수정");
                // if (me.storageExist) {

                if (me.isServerModeling) {
                    // server
                    if (me.changedByMe && me.isQueueModeling) {
                        // 서버o, 랩 x, 큐 o
                        if (!me.specVersion.includes('1.0') && !me.isReadModeling) {
                            var postObj = {
                                action: 'valueModify',
                                editUid: me.userInfo.uid,
                                timeStamp: Date.now(),
                                item: JSON.stringify(diff)
                            }
                            var key = await me.pushObject(`db://definitions/${me.projectId}/queue`, postObj)
                            me.changedByMeKeys.push(key)
                        }
                        me.changedByMe = false
                        me.changed = true
                        console.log('=== Push ModifiedElement ===')
                    } else if (!me.isQueueModeling && me.specVersion == '1.0' && !me.isReadModeling) {
                        // 서버o, 랩 x, 큐 x
                        var putValue = {
                            value: JSON.stringify(me.value)
                        }
                        var versionName = me.information.lastVersionName
                        me.putObject(`db://definitions/${me.projectId}/versionLists/${versionName}/versionValue`, putValue)
                        me.localUndoRedoStorage(diff)
                    }

                } else if (!me.isServerModeling && !me.isClazzModeling) {
                    // 서버x, 랩x, 큐x
                    var proId = me.projectId
                    var lists = await me.getObject(`localstorage://localLists`)
                    if (lists) {
                        var index = lists.findIndex(list => list.projectId == me.projectId)

                        if (index != -1) {
                            lists[index].lastModifiedDate = Date.now()
                            if (me.initLoad) {
                                me.changedTemplateCode = true
                            }
                        }
                    }

                    me.putObject(`localstorage://localLists`, lists)
                    me.putObject(`localstorage://${proId}`, me.value)
                    me.localUndoRedoStorage(diff)
                } else if (!me.isServerModeling && me.isClazzModeling) {
                    // 서버x, 랩 o, 큐x
                    me.localUndoRedoStorage(diff)
                }

            },
            bindEvents: function (opengraph) {
                var me = this;
                var el = me.$el;
                var canvasEl = $(opengraph.container);
                if (!canvasEl || !canvasEl.length) {
                    return;
                }
                this.canvas = opengraph.canvas;
                //아이콘 드래그 드랍 이벤트 등록
                $(el).find('.draggable').draggable({
                    start: function () {
                        canvasEl.data('DRAG_SHAPE', {
                            'component': $(this).attr('_component'),
                            'width': $(this).attr('_width'),
                            'height': $(this).attr('_height'),
                            'description': $(this).attr('_description'),
                            'label': $(this).attr('_label')
                        });
                    },
                    helper: 'clone',
                    appendTo: canvasEl
                });

                canvasEl.droppable({
                    drop: function (event, ui) {
                        var componentInfo = canvasEl.data('DRAG_SHAPE'),
                            shape, element;
                        if (componentInfo) {
                            var dropX = event.pageX - canvasEl.offset().left + canvasEl[0].scrollLeft;
                            var dropY = event.pageY - canvasEl.offset().top + canvasEl[0].scrollTop;
                            var scale = opengraph.canvas._CONFIG.SLIDER[0].innerText / 100

                            dropX = dropX / scale;
                            dropY = dropY / scale;

                            componentInfo = {
                                component: componentInfo.component,
                                x: dropX,
                                y: dropY,
                                width: parseInt(componentInfo.width, 10),
                                height: parseInt(componentInfo.height, 10),
                                label: componentInfo.label ? componentInfo.label : '',
                                description: componentInfo.description ? componentInfo.description : ''
                            }


                            me.addElement(componentInfo);
                        }
                        canvasEl.removeData('DRAG_SHAPE');
                    }
                });
            },
            toggleGrip: function () {
                this.dragPageMovable = !this.dragPageMovable;

                if (this.dragPageMovable) {
                    this.cursorStyle = 'cursor: url("/static/image/symbol/hands.png"), auto;';
                    this.handsStyle = ' color: #ffc124;';
                } else {
                    this.cursorStyle = null;
                    this.handsStyle = null;
                }
            },
            automaticGuidanceChange: function () {
                this.automaticGuidance = !this.automaticGuidance;

                if (this.automaticGuidance) {
                    this.cursorStyle = 'cursor: url("/static/image/symbol/hands.png"), auto;';
                    this.handsStyle = ' color: #ffc124;';
                } else {
                    this.cursorStyle = null;
                    this.handsStyle = null;
                }
            },
            undo() {
                var me = this

                if (me.isQueueModeling) {
                    if (me.isServerModeling) {
                        me.firebaseUndo()
                    } else {
                        me.localUndo()
                    }
                } else {
                    me.localUndo()
                }

            },
            redo() {
                var me = this
                if (me.isQueueModeling) {
                    if (me.isServerModeling) {
                        me.firebaseRedo()
                    } else {
                        me.localRedo()
                    }
                } else {
                    me.localRedo()
                }
            },
            localUndo() {
                var me = this
                var undoElement
                if (me.undoRedoArray.length > 0) {
                    me.undoRedoIndex = me.undoRedoIndex - 1
                    undoElement = me.undoRedoArray[me.undoRedoIndex] ? JSON.parse(me.undoRedoArray[me.undoRedoIndex]) : null

                    if (!undoElement) {
                        me.undoRedoIndex = 0
                        return
                    }

                    var type = Object.keys(undoElement)[0]
                    var diff = undoElement[type]
                    var id = Object.keys(undoElement[type])[0]
                    var value = Object.values(diff)
                    me.changedByUndoRedo = true


                    if (Array.isArray(value[0])) {
                        if (value[0].length == 1) {
                            me.value[type][id] = null
                        } else if (value[0].length == 2) {
                            me.$set(me.value[type], id, value[0][0])
                        }
                    } else if (typeof value == 'object') {
                        jsondiffpatch.patch(me.value[type], jsondiffpatch.reverse(diff));
                    }
                }
            },
            localRedo() {
                var me = this
                var redoElement
                if (me.undoRedoArray.length > 0) {

                    redoElement = me.undoRedoArray[me.undoRedoIndex] ? JSON.parse(me.undoRedoArray[me.undoRedoIndex]) : null
                    me.undoRedoIndex = me.undoRedoIndex + 1

                    if (!redoElement) {
                        me.undoRedoIndex = me.undoRedoArray.length
                        return
                    }

                    var type = Object.keys(redoElement)[0]
                    var diff = redoElement[type]
                    var id = Object.keys(redoElement[type])[0]
                    var value = Object.values(diff)
                    me.changedByUndoRedo = true

                    if (Array.isArray(value[0])) {
                        if (value[0].length == 1) {
                            me.$set(me.value[type], id, value[0][0])
                        } else if (value[0].length == 2) {
                            me.value[type][id] = null
                        }
                    } else if (typeof value == 'object') {
                        jsondiffpatch.patch(me.value[type], diff);
                    }

                }

            },
            localUndoRedoStorage(diff) {
                var me = this
                if (me.changedByUndoRedo) {
                    me.changedByUndoRedo = false
                } else {

                    var lastIndex = me.undoRedoArray.length
                    if (lastIndex != me.undoRedoIndex) {
                        me.undoRedoArray.splice(me.undoRedoIndex, lastIndex - me.undoRedoIndex)
                    }
                    me.undoRedoArray.push(JSON.stringify(diff))
                    me.undoRedoIndex = me.undoRedoIndex + 1

                }
            },
            async firebaseUndo() {
                var me = this
                me.overlayText = 'Undoing'
                me.undoDisable = true
                var keySnap = await me.getLastQueue()
                if(keySnap){
                    var currentKey = keySnap[0].key
                    var prevValue = await me.getUndoTarget(currentKey)
                    if (prevValue) {
                        me.undoRedoDraw(prevValue, 'undo')
                    }
                }
                me.overlayText = null
            },
            getUndoTarget(currentKey) {
                var me = this

                return new Promise(async function (resolve, reject) {
                    var backCount = 0;
                    var nextKey = null
                    var nextValue = null
                    var drawQueue = null

                    while (currentKey) {
                        var keyValue = await me.getUndoRedoQueue(currentKey)
                        // 0 - 다음
                        // 1 - 현재
                        nextValue = keyValue[0]
                        nextKey = nextValue.key
                        currentKey = keyValue[1] ? keyValue[1].key : null
                        if (!nextValue) break; // last

                        if (nextValue.editUid != me.userInfo.uid) continue; //다른사람 큐 는 건너 뛰기

                        if (nextValue.action == 'undo') backCount = backCount + 1;
                        else if (nextValue.action == 'redo') backCount = backCount - 1;
                        else backCount = backCount - 1;

                        if (backCount == -1) break;   //undo시 사용
                    }
                    // 마지막 큐
                    if(keyValue.length == 1){
                        me.undoDisable = true
                    }else{
                        me.undoDisable = false
                        if(me.redoDisable) me.redoDisable = false //redo 활성화
                    }

                    if (nextKey && backCount == -1) {
                        drawQueue = {
                            childKey: nextKey,
                            childValue: nextValue
                        }
                    }
                    resolve(drawQueue)
                })

            },
            async firebaseRedo() {
                var me = this
                me.overlayText = 'Redoing'
                me.redoDisable = true
                var keySnap = await me.getLastQueue()
                if(keySnap){
                    var currentKey = keySnap[0].key
                    var prevValue = await me.getRedoTarget(currentKey)
                    if (prevValue) {
                        me.undoRedoDraw(prevValue, 'redo')
                    }
                }
                me.overlayText = null
            },
            async getRedoTarget(nextKey) {
                var me = this
                return new Promise(async function (resolve, reject) {
                    var backCount = 0;
                    var currentKey = null
                    var currentValue = null
                    var drawQueue = null

                    while (nextKey) {
                        var keyValue = await me.getUndoRedoQueue(nextKey)
                        // 0 - 현재
                        // 1 - 다음
                        currentValue = keyValue[0]
                        currentKey = currentValue.key
                        nextKey = keyValue[1] ? keyValue[1].key : null
                        if (!currentValue) break; // last

                        if (currentValue.editUid != me.userInfo.uid) continue; //다른사람 큐 는 건너 뛰기

                        if (currentValue.action == 'undo') backCount = backCount - 1;
                        else if (currentValue.action == 'redo') backCount = backCount + 1;
                        else backCount = backCount - 1;

                        if (backCount == -1) break;   //undo시 사용
                    }

                    if (currentKey && currentValue.action == 'undo') {
                        me.redoDisable = false
                        if(me.undoDisable) me.undoDisable = false //undo 활성화
                        drawQueue = {
                            childKey: currentKey,
                            childValue: currentValue
                        }
                    }else{
                        me.redoDisable = true
                    }
                    resolve(drawQueue)

                })
            },
            copy: function () {
            },
            paste: function () {
            },
            unselectedAll: function (newVal) {
                var me = this
                Object.values(me.value.elements).forEach(function (definition) {
                    if (definition != null) {
                        definition.selected = false
                    }
                })
                Object.values(me.value.relations).forEach(function (relation) {
                    if (relation != null) {
                        relation.selected = false
                    }
                })
            },
            validateRelation(fromId, toId) {
                var me = this
                try {
                    var relations = me.value.relations
                    if (relations) {
                        var index = Object.values(relations).findIndex(relation => relation && relation.from == fromId && relation.to == toId)
                        if (index == -1) {
                            return true
                        }
                    }
                    return false
                } catch (e) {
                    return true
                }
            },
            onConnectShape: function (edge, from, to) {

                var me = this;
                //존재하는 릴레이션인 경우 (뷰 ��포넌트), 데이터 매핑에 의해 자동으로 from, to 가 변경되어있기 때문에 따로 로직은 필요없음.
                //=> 바뀌어야 함.
                //신규 릴레이션인 경우에는 릴레이션 생성
                var edgeElement, originalData;
                var isComponent = false;
                if (edge.shape) {
                    edgeElement = edge;
                } else {
                    isComponent = true;
                    edgeElement = edge.element;
                }
                // console.log(from, to)

                if (edgeElement && from && to) {
                    var vertices = '[' + edgeElement.shape.geom.vertices.toString() + ']';
                    var componentInfo = {
                        component: 'class-relation',
                        sourceElement: from.$parent,
                        targetElement: to.$parent,
                        vertices: vertices,
                        isFilled: true,
                        isRelation: true,
                        relationView: {
                            style: JSON.stringify({}),
                            value: vertices,
                        }
                    }

                    from.$parent.value.elementView.id = from.id;
                    to.$parent.value.elementView.id = to.id;

                    if (isComponent) {
                        me.canvas.removeShape(edgeElement, true);
                        //this.removeComponentByOpenGraphComponentId(edgeElement.id);
                        //기존 컴포넌트가 있는 경우 originalData 와 함께 생성
                        // this.addElement(componentInfo)
                    } else {
                        me.canvas.removeShape(edgeElement, true);
                        //기존 컴포넌트가 없는 경우 신규 생성
                        // this.addElement(componentInfo);
                    }
                    // this.syncOthers();

                    if (me.validateRelation(from.id, to.id)) {
                        me.addElement(componentInfo);
                    }

                }
            },
            addElement: function (componentInfo, bounded) {
                this.enableHistoryAdd = true;
                var me = this;
                var additionalData = {};
                var vueComponent = me.getComponentByName(componentInfo.component);
                var element;

                if (componentInfo.isRelation && componentInfo.component.includes('relation')) {
                    /* make Relation */
                    element = vueComponent.computed.createNew(
                        this.uuid(),
                        componentInfo.sourceElement.value,
                        componentInfo.targetElement.value,
                        componentInfo.vertices,
                    );

                } else {
                    /* make Element */
                    element = vueComponent.computed.createNew(
                        this.uuid(),
                        componentInfo.x,
                        componentInfo.y,
                        componentInfo.width,
                        componentInfo.height,
                        componentInfo.description,
                        componentInfo.label
                    );
                }

                me.addElementPush(element)

            },
            addElementPush(element) {
                var me = this
                var location = element.elementView ? me.value.elements : me.value.relations
                var eleId = element.elementView ? element.elementView.id : element.relationView.id

                // if (me.storageExist) {
                if (me.isServerModeling && me.isQueueModeling ) {
                    //server
                    me.changed = true
                    var action = element.relationView ? 'relationPush' : 'elementPush'
                    if (!Object.keys(location).includes(eleId)) {

                        //STATUS_COMPLETE
                        me.$set(location, eleId, element)
                        //STATUS_COMPLETE_addElementPush
                        me.$nextTick(function () {
                            me.$EventBus.$emit(`${eleId}`, {action: action, STATUS_COMPLETE: false})
                        })
                        var postObj = {
                            action: action,
                            editUid: me.userInfo.uid,
                            timeStamp: Date.now(),
                            item: JSON.stringify(element)
                        }
                        me.pushObject(`db://definitions/${me.projectId}/queue`, postObj)
                        console.log('added:server')
                    }

                } else {
                    if (!Object.keys(location).includes(eleId)) {
                        me.$set(location, eleId, element)

                        if (me.initLoad) {
                            me.changedTemplateCode = true
                        }
                        console.log('added:localstorage,kubernetes')
                    }
                }

            },
            uuid: function () {
                function s4() {
                    return Math.floor((1 + Math.random()) * 0x10000)
                        .toString(16)
                        .substring(1);
                }

                return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
                    s4() + '-' + s4() + s4() + s4();
            },
            dbuid: function () {
                function s4() {
                    return Math.floor((1 + Math.random()) * 0x10000)
                        .toString(16)
                        .substring(1);
                }

                return s4() + s4() + s4() + s4() + s4() + s4() + s4() + s4();
            },
            getComponent(componentName) {
                let component = null
                let parent = this.$parent
                while (parent && !component) {
                    if (parent.$options.name === componentName) {
                        component = parent
                    }
                    parent = parent.$parent
                }
                return component
            },
            getComponentByName: function (name) {
                var componentByName;
                $.each(window.Vue._components, function (i, component) {
                    if (component.name == name) {
                        componentByName = component;
                    }
                });
                return componentByName;
            },


        }
    }

</script>

<style scoped lang="scss" rel="stylesheet/scss">
    .input-name {
        background-color: #ffffff;
        full-width: 10px;
    }

    .canvas-panel {
        top: 0;
        bottom: 0;
        left: 10;
        right: 0;
        /*position: relative;*/
        position: absolute;
        overflow: hidden;
        width: 100%;
        height: 100%;

        .fullcanvas {
            position: relative;
            width: 100%;
            height: 100%;
            top: 10%;
            left: 0;
            overflow: hidden;
        }

        .fullcanvashands {
            position: absolute;
            width: 100%;
            height: 100%;
            top: 10%;
            left: 0;
            overflow: hidden;
            cursor: url('../../../../public/static/image/symbol/hands.png'), auto;
        }

        .toolsSide {
            position: absolute;
            width: 100px;
            left: 20px;
            top: 20px;
            padding: 4px;
            overflow: hidden;

            .icons {
                margin-top: 5px;
                margin-bottom: 5px;
            }

            .hands {
                margin-top: 5px;
                margin-bottom: 5px;
            }
        }

        .tools {
            position: absolute;
            width: 48px;
            left: 20px;
            top: 20px;
            padding: 4px;
            overflow: hidden;

            .icons {
                margin-top: 5px;
                margin-bottom: 5px;
            }

            .hands {
                margin-top: 5px;
                margin-bottom: 5px;
            }
        }

        .zoom {
            position: absolute;
            width: 42px;
            right: 20px;
            bottom: 120px;

            .icons {
                font-size: 25px;
                margin-left: 10px;
                margin-top: 5px;
                margin-bottom: 5px;
            }

            .hands {
                font-size: 25px;
                margin-left: 10px;
                margin-top: 5px;
                margin-bottom: 5px;
            }
        }

        .icons {
            cursor: pointer;
            font-size: 30px;

            &:hover {
                color: #1a76d2;
            }
        }

        .hands {
            cursor: pointer;
            font-size: 30px;
            color: #ffc124;
        }

        .export,
        .history,
        .import,
        .save {
            position: absolute;
            padding: 8px;

            .icons {
                font-size: 25px;
                margin-left: 10px;
            }
        }

        .import {
            left: 80px;
            bottom: 20px;
        }

        .export {
            left: 180px;
            bottom: 20px;
        }

        .history {
            left: 280px;
            bottom: 20px;
        }
    }

    .text-reader input[type="file"] { /* 파일 필드 숨기기 */
        position: absolute;
        width: 1px;
        height: 1px;
        padding: 0;
        margin: -1px;
        overflow: hidden;
        clip: rect(0, 0, 0, 0);
        border: 0;
    }

    /* The whole thing */
    .custom-menu {
        display: none;
        z-index: 1000;
        position: absolute;
        overflow: hidden;
        border: 1px solid #CCC;
        white-space: nowrap;
        font-family: sans-serif;
        background: #FFF;
        color: #333;
        border-radius: 5px;
        padding: 0;
    }

    /* Each of the items in the list */
    .custom-menu li {
        padding: 8px 12px;
        cursor: pointer;
        list-style-type: none;
        transition: all 0.3s ease;
        user-select: none;
    }

    .custom-menu li:hover {
        background-color: #DEF;
    }

    /*.moveable-line.moveable-rotation-line {*/
    /*    height: 40px;*/
    /*    width: 1px;*/
    /*    transform-origin: 0.5px 39.5px;*/
    /*}*/

    /*.moveable {*/
    /*    font-family: "Roboto", sans-serif;*/
    /*    position: relative;*/
    /*    width: 400px;*/
    /*    height: 130px;*/
    /*    text-align: center;*/
    /*    font-size: 40px;*/
    /*    margin: 0 auto;*/
    /*    font-weight: 100;*/
    /*    letter-spacing: 1px;*/
    /*    background: white;*/
    /*}*/


    .video-list {
        height: 160px;
        width: auto;
        margin-left: 2px;
        background: transparent;
    }

    .video-list div {
        padding: 2px;
    }

    .video-item {
        display: inline-block;
        padding: 2px;
    }

    .rtc {
        .button {
            color: red;
        }

        .buttonHover {
            background-Color: white;
        }

        .content {
            background-Color: white;
        }

        .titlebar {
            background-color: white;
        }
    }

</style>